import React, { useState } from "react";
import styled from "styled-components";
import upArrow from "../assets/upArrow.png";
export default function ScrollToTop() {
	const [scrollState, setScrollState] = useState(false);
	const toTop = () => {
		window.scrollTo({ top: 0 });
	};
	window.addEventListener("scroll", () => {
		window.pageYOffset > 200 ? setScrollState(true) : setScrollState(false);
	});
	return (
		<ToTop onClick={toTop} scrollState={scrollState}>
			<div className="scrollImgWrapper">
				<img src={upArrow} alt="" />
			</div>
			<p className="scrollText">Top</p>
		</ToTop>
	);
}

const ToTop = styled.div`
	display: ${({ scrollState }) => (scrollState ? "block" : "none")};
	position: fixed;
	cursor: pointer;
	z-index: 10;
	bottom: 1rem;
	right: 2rem;
	border-radius: 2rem;
	background-color: #1900ff39;
	padding: 0.5rem 0.6rem;
	.scrollImgWrapper {
		padding: 5px;
		img {
			height: 1.5rem;
			width: 1.5rem;
			margin-top: 3px;
			border-radius: 2rem;
		}
	}
	.scrollText {
		line-height: 5px;
		font-style: italic;
		padding: 5px;
		font-family: "Courier New", Courier, monospace;
		font-weight: 600;
	}
`;
